import { render } from "./BaseBreadcrumb.vue?vue&type=template&id=63b860e3"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__